import { Box, Typography } from "@mui/material";

export const CaseStudy = ({ title, description, image, initial }) => {
  // useScrollReveal([
  //   {
  //     selector: ".revealPortfolio",
  //     options: {
  //       distance: "100px",
  //       duration: 1000,
  //       easing: "ease-out",
  //       origin: "left",
  //       reset: false,
  //       interval: 500,
  //     },
  //   },
  // ]);
  return (
    <Box
      sx={{
        width: "80%",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        gap: "40px",
      }}
      className={initial ? "revealPortfolio" : ""}
    >
      <Box
        component="img"
        src={image}
        sx={{
          width: { xs: "100%", md: "400px", height: "267px" },
          borderRadius: "8px",
          objectFit: "container",
        }}
      />
      <Box sx={{ width: { xs: "100%", md: "62%" } }}>
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "17px", md: "22px" },
            mb: "5px",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{ fontSize: { xs: "14px", md: "19px" }, textAlign: "justify" }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
};
